<template>
    <div role="tabpanel" :aria-hidden="!isSelected" class="tab-pane" :class="isSelected ? 'active' : null" :style="{ display: isSelected ? null : 'none' }" :aria-labelledby="`${uid}-tab-button`">
        <slot />
    </div>
</template>

<script>
import uniqid from 'uniqid';

export default {
    name: 'AlzataTab',
    props: {
        title: String,
        showMe: Boolean
    },
    mounted() {
        this.$parent.registerTab(this);
    },
    computed: {
        isSelected() {
            return this.$parent.selectedTab === this;
        },
    },
    data() {
        return {
            uid: uniqid(),
        };
    },
};
</script>